import React, { useState } from "react";
import { TextField } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";

function SearchBar() {
  const [inputValue, setInputValue] = useState("");

  function updateInput(e) {
    const value = e.target.value;
    setInputValue(value);
  }

  function routeSearch(input) {
    if (input[0] === "#") {
      return "/hashtags" + "/" + input.substring(1, input.length);
    } else {
      return "/users" + "/" + input;
    }
  }

  return (
    <div className="search-bar">
      <TextField
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        variant="outlined"
        type="text"
        onChange={updateInput}
        value={inputValue}
        placeholder="search for a user or #"
      />
      <Link className="search-button" to={routeSearch(inputValue)}>
        <Button variant="contained">Go</Button>
      </Link>
    </div>
  );
}

export default SearchBar;
